import { formatNumber } from '@/utils';

const formattedTooltip = (coordinate) => {
  const formattedPercent = Math.round(coordinate.percentage);
  const formattedFans = formatNumber(coordinate.y);

  return `
    <div class="tooltip-pie">
      <div class="tooltip-pie__point" style="background: ${coordinate.color};"></div>
      <span class="tooltip-pie__name">${coordinate.key} </span>

      <div class="tooltip-pie__bottom">
        <span class="tooltip-pie__fans">${formattedFans}</span>
        <span class="tooltip-pie__percent">(${formattedPercent}%)</span>
      </div>
    </div>      
  `;
};

export default formattedTooltip;
